import { useEffect, useState } from "react";

export const useTimer = (date: Date) => {
    const getTimeLeft = () => Math.floor((date.getTime() - Date.now()) / 1000);
    const [timeLeft, setTimeLeft] = useState(getTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                const newTime = getTimeLeft();
                if (newTime <= 0) {
                    clearInterval(timer);
                    return 0;
                }
                return newTime;
            });
        }, 250);

        return () => clearInterval(timer);
    }, [date]);

    return timeLeft;
};
